module.exports = __webpack_public_path__ + "static/img/planet-right.a57eecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet-right.png
// module id = 341
// module chunks = 0